import type { ButtonHTMLAttributes, ReactNode } from 'react';
import Apertavel from '@/components/movimento/Apertavel';

type Variante = 'primario' | 'secundario' | 'fantasma' | 'perigo' | 'perigo-contorno' | 'whatsapp';
type Tamanho = 'md' | 'lg';

interface BotaoProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante;
  tamanho?: Tamanho;
  carregando?: boolean;
  icone?: string;
  cheio?: boolean;
  children: ReactNode;
}

const VARIANTES: Record<Variante, string> = {
  primario: 'bg-primary-500 text-white hover:bg-primary-600',
  secundario: 'bg-white text-foreground-900 border border-secondary-300 hover:bg-background-50',
  fantasma: 'bg-transparent text-primary-700 hover:bg-primary-50',
  perigo: 'bg-danger-500 text-white hover:bg-danger-600',
  'perigo-contorno': 'bg-white text-danger-600 border border-danger-300 hover:bg-danger-50',
  whatsapp: 'bg-[#25D366] text-white hover:brightness-95',
};

const TAMANHOS: Record<Tamanho, string> = {
  md: 'h-11 px-5 text-sm',
  lg: 'h-[52px] px-6 text-base',
};

export default function Botao({
  variante = 'primario',
  tamanho = 'md',
  carregando = false,
  icone,
  cheio = false,
  className = '',
  disabled,
  children,
  ...rest
}: BotaoProps) {
  return (
    <Apertavel
      disabled={disabled || carregando}
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:cursor-not-allowed disabled:opacity-60 ${
        cheio ? 'w-full sm:w-auto' : ''
      } ${TAMANHOS[tamanho]} ${VARIANTES[variante]} ${className}`}
      {...rest}
    >
      {carregando ? (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-loader-4-line animate-spin" />
        </span>
      ) : icone ? (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className={icone} />
        </span>
      ) : null}
      {children}
    </Apertavel>
  );
}